import { Controller } from "@hotwired/stimulus";

  export default class extends Controller {
    remove(event) {
      event.preventDefault();
      const frame = this.element;
      if (frame) {
        frame.remove();
      }
    }
  }